import { AccordionFrontend } from '@ui/Accordion/Accordion';
import React from 'react';

interface FunctionItem {
    title: string;
    subtitle?: string;
    description?: React.ReactNode;
    color?: string;
}

interface Props {
    functions: FunctionItem[];
}

export const FunctionsSection: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({ functions }) => {
    const [openKeys, setOpenKeys] = React.useState<Set<string>>(() => new Set());

    const toggle = React.useCallback((key: string) => {
        setOpenKeys((prev) => {
            const next = new Set(prev);
            if (next.has(key)) {
                next.delete(key);
            } else {
                next.add(key);
            }
            return next;
        });
    }, []);

    return (
        <div className="tw-my-12 tw-flex tw-flex-col tw-gap-4">
            {functions.map((func, index) => {
                const isOpen = openKeys.has(func.title);
                const contentId = `functions-section-panel-${index}`;

                return (
                    <AccordionFrontend
                        key={func.title}
                        id={contentId}
                        title={func.title}
                        subtitle={func.subtitle}
                        color={func.color}
                        isOpen={isOpen}
                        onToggle={() => toggle(func.title)}
                    >
                        {func.description}
                    </AccordionFrontend>
                );
            })}
        </div>
    );
};
